import { render, staticRenderFns } from "./kdTestTab.vue?vue&type=template&id=1e883007&scoped=true"
import script from "./kdTestTab.vue?vue&type=script&setup=true&lang=js"
export * from "./kdTestTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e883007",
  null
  
)

export default component.exports